'use strict';
module.exports = false;



/*****************
 ** WEBPACK FOOTER
 ** ./~/styled-components/~/supports-color/browser.js
 ** module id = 597
 ** module chunks = 0
 **/